import { PagingResponse } from '@/@types/responses/common/PagingResponse'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { BuildType } from '@/@types/responses/build_type/BuildType'
import { BuildTypeDropdownOption } from '@/@types/responses/build_type/BuildTypeDropdownOption'
import { BuildTypeDetails } from '@/@types/responses/build_type/BuildTypeDetails'
import { BuildTypeMessage } from '@/@types/messages/BuildTypeMessage'
import { MiscellaneousService } from './miscellaneous.service'
import { ObjectCreatedResponse } from '@/@types/responses/common/ObjectCreatedResponse'
import { DropdownOptionsResponse } from '@/@types/responses/common/DropdownOptionsResponse'

export class BuildTypeService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public createBuildType(buildTypeMessage: BuildTypeMessage): Promise<ObjectCreatedResponse<number>> {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildTypeMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types`, this.miscellaneousService, requestOptions).then(async response => {
      const json = await response.json()
      return new ObjectCreatedResponse<number>(json.id)
    })
  }

  public deleteBuildType(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public getBuildType(id: number): Promise<BuildTypeDetails> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types/${id}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return new BuildTypeDetails(json.id, json.cartridgeRequired, json.name, json.createdByUser, json.createdDate, json.lastModifiedByUser, json.lastModifiedDate)
    })
  }

  public getBuildTypeDropdownOptions(): Promise<DropdownOptionsResponse<BuildTypeDropdownOption>> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types/dropdown-options`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as DropdownOptionsResponse<BuildTypeDropdownOption>
    })
  }

  public searchBuildTypes(searchTerm: string, cartridgeRequired: boolean, pageNumber: number, pageSize: number, sortField: string, ascending: boolean): Promise<PagingResponse<BuildType>> {
    const queryString = `?searchTerm=${searchTerm}&cartridgeRequired=${cartridgeRequired}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&ascending=${ascending}`

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types${queryString}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as PagingResponse<BuildType>
    })
  }

  public updateBuildType(id: number, buildTypeMessage: BuildTypeMessage): Promise<void> {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildTypeMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/build-types/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
